// ENV:localhost/development/production
const appVersion = "1.0.0";
const baseDomain =
  process.env.REACT_APP_BASE_DOMAIN || "https://taprocore.taprodevpos.com";

const commonConfig = {
  webName: "pos-system",
  address: "",
  mobile: "",
  email: "",
  whatsapp: "",
  devsSite: "",
  noImage: "no_image_available.jpg",
};

const AppConstant = {
  BILLING_LAYOUT_KEY: "pos_billing_layout",
  BILL_TYPE_KEY: "pos_bill_type",
  PANEL_VIEW_KEY: "pos_panel_view",
  sessionStorageKey: "pos_cart_data",
  panelStorageKey: "pos_panel_view",
};

const config = {
  ...commonConfig,
  webLink: baseDomain,
  storeWebLink:
    process.env.REACT_APP_STORE_WEBLINK || "https://app.taprodevpos.com",
  server: baseDomain,
  serverapi: `${baseDomain}/api`,
  imagepath: process.env.REACT_APP_IMAGE_PATH || `${baseDomain}/images`,
  userGuideUrl:
    process.env.REACT_APP_USER_GUIDE_URL ||
    "https://app.taprodevpos.com/userguides",
  kotPrinterServer:
    process.env.REACT_APP_KOT_PRINTER_SERVER || "http://localhost:5000",
  ...AppConstant,

  // Web routes
  login: "/",
  loginSuccess: "login-success",
  forgotPassword: "forgot-password",

  //System routes
  dashboard_overview: "dashboard_overview",
  sales_billing: "sales_billing",
  sales_return: "sales_return",
  sales_history: "sales_history",
  sales_expenses: "sales_expenses",
  sales_cheques: "sales_cheques",
  sales_quotation: "sales_quotation",
  product_manage: "product_manage",
  stock_adjustment: "stock_adjustment",
  stock_history: "stock_history",
  purchase_manage: "purchase_manage",
  raw_material_manage: "raw_material_manage",
  raw_material_purchase: "raw_material_purchase",
  recipe_manage: "recipe_manage",
  production_manage: "production_manage",
  stock_transfer: "stock_transfer",
  supplier_manage: "supplier_manage",
  customer_manage: "customer_manage",
  credits_summery: "credits_summery",
  customer_ledger: "customer_ledger",
  supplier_ledger: "supplier_ledger",
  report_sales: "report_sales",
  report_inventory: "report_inventory",
  report_purchase: "report_purchase",
  report_expenses: "report_expenses",
  report_credit: "report_credit",
  report_others: "report_others",

  employee_manage: "employee_manage",
  attendance_manage: "attendance_manage",
  payroll_manage: "payroll_manage",
  leave_manage: "leave_manage",
  user_manage: "user_manage",
  store_manage: "store_manage",

  web_info: "web-info",
  bank_manage: "bank_manage",
  whatsapp_chatbot: "whatsapp-chatbot",
  online_orders: "online-orders",
  repair_jobs: "repair_jobs",
  courier_manage: "courier_manage",
  monthly_attendance_sheet: "monthly_attendance_sheet",
  store_live_tracking: "store-live-tracking",
  barcode_editor: "barcode_editor",
  access_policies: "access_policies",
  ad_campaigns: "ad-campaigns",
  ad_list: "ad-list",
  ad_detail: "ad/:ad_id",

  system_admin_tenants: "system_admin_tenants",

  report: {
    sales_ledger: "reports/sales-ledger",
    item_profit: "reports/item-profit",
    cash_flow: "reports/cash-flow",
    cheques: "reports/cheques",
    discounts: "reports/discounts",
    non_cash_payments: "reports/non-cash-payments",
    employee_performance: "reports/employee-performance",
    sign_off_list: "reports/sign-off-list",
    sign_off_detail: "reports/sign-off-detail",
    product_stock: "reports/product-stock",
    expiring_items: "reports/expiring-items",
    purchases: "reports/purchases",
    purchased_products: "reports/purchased-products",
    returned_items: "reports/returned-items",
    sold_items: "reports/sold-items",
    by_cashier: "reports/by-cashier",
    total_items: "reports/total-items",
    products: "reports/products",
    purchase_returns: "reports/purchase-returns",
    purchase_payments: "reports/purchase-payments",
    expense_by_seller: "reports/expense-by-seller",
    debtors: "reports/debtors",
    creditors: "reports/creditors",
    customers: "reports/customers",
    suppliers: "reports/suppliers",
    raw_stock_issue: "reports/raw-stock-issue",
    raw_material_purchases: "reports/raw-material-purchases",
    productions: "reports/productions",
    transfers: "reports/transfers",
  },

  //commons
  appLogo: "applogo.jpg",
  signInBg: "signInBg.jpeg",
  appVersion: appVersion,
};

export default config;
